import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import {
  GetAllSubscriptionPlansPlanResponseDto,
  GetBillingAccountResponseDto,
  GetBillingAccountResponseSubscriptionDto,
} from 'app/API';
import { useNavigate } from 'react-router';
import { ActiveCard } from '../Cards/ActiveCard';
import { CanceledCard } from '../Cards/CanceledCard';
import { PaymentFailedCard } from '../Cards/PaymentFailedCard';
import { TrialingCard } from '../Cards/TrialingCard';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  billingAccount: GetBillingAccountResponseDto;
  subscription: GetBillingAccountResponseSubscriptionDto;
  plan: GetAllSubscriptionPlansPlanResponseDto;
  availablePlans: GetAllSubscriptionPlansPlanResponseDto[];
  onChange?: () => void;
};

export const SubscriptionCard = ({ billingAccount, subscription, plan, availablePlans, onChange }: TProps) => {
  const { openModal, closeModal } = useModalContext();
  const navigate = useNavigate();
  const { organization } = useAuthContext();

  const openSubscriptionPage = () => {
    navigate(routes.autoScriptOneSubscriptionDetails.make(organization?.slug ?? '', subscription.id));
  };

  const onChooseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    openModal(ModalNamesEnum.ChooseASOneSubscriptionModal, {
      billingAccountId: billingAccount?.id,
      onSuccess: () => {
        closeModal();
        if (onChange) {
          onChange();
        }
      },
    });
  };

  const reload = () => {
    closeModal();
    if (onChange) {
      onChange();
    }
  };

  // Todo: we need to do something here. Coz this is not a failed state
  if (subscription.status === 'incomplete' || subscription.status === 'incomplete_expired') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <PaymentFailedCard billingAccountId={billingAccount.id} subscription={subscription} reload={reload} />
      </Wrapper>
    );
  }

  if (subscription.status === 'canceled') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <CanceledCard plan={plan} subscription={subscription} onButtonClick={onChooseClick} />
      </Wrapper>
    );
  }

  if (subscription.status === 'past_due' || subscription.status === 'unpaid') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <PaymentFailedCard billingAccountId={billingAccount.id} subscription={subscription} reload={reload} />
      </Wrapper>
    );
  }

  if (subscription.status === 'trialing') {
    return (
      <Wrapper onClick={openSubscriptionPage}>
        <TrialingCard plan={plan} subscription={subscription} billingAccount={billingAccount} reload={reload} />
      </Wrapper>
    );
  }

  // Default is Active
  return (
    <Wrapper onClick={openSubscriptionPage}>
      <ActiveCard
        plan={plan}
        subscription={subscription}
        billingAccount={billingAccount}
        availablePlans={availablePlans}
        reload={reload}
      />
    </Wrapper>
  );
};
